import React, { FC, useRef, useEffect } from "react"
import { useCreation } from "ahooks"
import ReactEcharts from "echarts-for-react"
import { EChartOption } from "echarts"
import Env from "@util/env"

type ILineDotedProps = {
  data: {
    legend: string[]
    data: { name: string; data: number[] }[]
  }
  color?: string[]
}

const LineDoted: FC<ILineDotedProps> = ({ data, color }) => {
  const ref = useRef()
  const options = useCreation<EChartOption>(() => {
    const _options: EChartOption = {
      legend: {
        // data: data.data.map((d) => {
        //   return d.name
        // }),
        // icon: "roundRect",
        textStyle: {
          color: "#ffffff",
          fontSize: 12 * Env.getScale(),
        },
      },
      tooltip: {
        trigger: "axis",
        // formatter: `{b}: {c}`,
      },
      grid: {
        left: "4%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      color: color,
      xAxis: {
        type: "category",
        // axisLabel: {
        //   interval: isDefinedX ? 2 : 1,
        // },

        boundaryGap: false,
        data: data.legend,
        axisLine: {
          lineStyle: {
            color: "#81A3C3",
          },
        },
        axisLabel: {
          color: "#ffffff",
          fontSize: 12 * Env.getScale(),
        },
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: "#81A3C3",
          },
        },
      },
      yAxis: {
        type: "value",
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      series: data.data.map((d) => {
        return {
          name: d.name,
          data: d.data,
          type: "line",
          label: {
            normal: {
              show: true,
              position: "top",
              color: "#ffffff",
              fontSize: 12 * Env.getScale(),
            },
          },
        }
      }),
    }
    return _options
  }, [data])
  useEffect(() => {
    return () => {
      // @ts-ignore
      ref.current && ref.current.getEchartsInstance().dispose()
    }
  }, [ref])
  return (
    <div className="ct-line-flow" style={{ height: "100%" }}>
      <ReactEcharts
        ref={ref}
        option={options || {}}
        notMerge={true}
        lazyUpdate={true}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  )
}

export default LineDoted
